export default {
  init() {
    // ScrollTop class application
    (function($){
      // TODO: Maybe run check on load?
      $(window).scroll(function() {    
        var scroll = $(window).scrollTop();

        if (scroll >= 50) {
          $('body').addClass('not-top');
          if ( $(window).width() >= 992 ) {
            if ($('.main-header .search-container').is(':visible') ) {
              $('.main-header .search-container').hide();
            }
          }
        } else {
          $('body').removeClass('not-top');
          if ( $(window).width() >= 992 ) {
            if ( $('.main-header .search-container').is(':hidden') ) {
              $('.main-header .search-container').show(); 
            }
            if ( $('.main-header .menu-primary-menu-container').is(':hidden') ) {
              $('.main-header .menu-primary-menu-container').show(); 
            }
          }
        }
      });

      // Sections menu toggle
      $(function() {
        $('.sections-toggle').on('click', function () {
          var target = $( '#' + $(this).attr('aria-controls') );

          target.toggle();
          
          // Update aria properties
          if (target.is(':hidden')) {
            $(this).attr('aria-expanded', 'false');
            target.attr('aria-hidden', 'true');
          } else {
            $(this).attr('aria-expanded', 'true');
            target.attr('aria-hidden', 'false');
          }
        });

        // When clicking a section on mobile, close the section listing
        $('#sections-container-mobile a').on('click', function () {
          $('#sections-listing-mobile').attr('aria-hidden', 'false').hide();
          $('#sections-toggle-mobile').attr('aria-expanded', 'false');
        });
      });

      /**
       * Clears all data in a form
       * 
       * @param {*} form 
       */
      function clearForm(form) {
        // iterate over all of the inputs for the form
        // element that was passed in
        $(':input', form).each(function() {
          var type = this.type;
          var tag = this.tagName.toLowerCase(); // normalize case
          // it's ok to reset the value attr of text inputs,
          // password inputs, and textareas
          if (type == 'text' || type == 'password' || tag == 'textarea')
            this.value = '';
          // checkboxes and radios need to have their checked state cleared
          // but should *not* have their 'value' changed
          else if (type == 'checkbox' || type == 'radio')
            this.checked = false;
          // select elements need to have their 'selectedIndex' property set to -1
          // (this works for both single and multiple select elements)
          else if (tag == 'select')
            this.selectedIndex = -1;

          form.find('.chosen-select').trigger('chosen:updated');
        });
      }

      $('#sosp-advanced-search button.clear').on('click', function (e) {
        e.preventDefault();
        clearForm('#sosp-advanced-search');
      });

      // Makes the little search icon actually click to search
      $('.search-container .search-form .search-icon').on('click', function() {
        $(this).closest('form').submit();
      });


    })(jQuery);
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js